module.exports = __webpack_public_path__ + "img/logo-certif.1fb8fe9e.png";